import React, { useState, useRef, useCallback } from 'react';
import { StyledHeader } from './style';
import { Profile } from '../../Profile/profile';
import BellNotificationsDrawer from 'ui/Drawer/Drawers/BellNotificationsDrawer';
import { NotificationsBell } from 'admin/components/Header/NotificationsBell';
import { useAuth } from '../../../../hooks/useAuth';
import { Divider, Select, SelectOption, Spinner } from 'ui';
import { FarmData } from '../../../../types/FarmData';
import { useIntl } from 'react-intl';
import useQueryApiClient from '../../../../utils/useQueryApiClient';

const DefaultHeader = () => {
  const [bellOpen, setBellOpen] = useState(false);
  const [isSwitchingFarm, setIsSwitchingFarm] = useState(false);
  const [, setHasUnopened] = useState(false);
  const refetchBellCountRef = useRef<(() => void) | null>(null);

  const { user } = useAuth();
  const isAdmin = user?.isAdmin;
  const intl = useIntl();
  const farmId = user?.farmId ?? user?.farm?.id;

  const { data: farms } = useQueryApiClient({
    request: {
      url: `api/v2/farms/select`,
      disableOnMount: !isAdmin,
    },
  });

  const { appendData } = useQueryApiClient({
    request: {
      url: `/api/v2/user/farm-change/:id`,
      method: 'PATCH',
    },
    onSuccess: () => {
      window.location.reload();
    },
    onError: () => setIsSwitchingFarm(false),
  });

  const handleFarmChange = (farm: { value: number }) => {
    setIsSwitchingFarm(true);
    appendData({}, { id: farm.value });
  };

  const handleRefetchCount = useCallback((fn: () => void) => {
    refetchBellCountRef.current = fn;
  }, []);

  const handleNotificationViewed = useCallback(() => {
    refetchBellCountRef.current?.();
  }, []);

  return (
    <>
      <StyledHeader>
        <div className="right-side-header">
          {isAdmin && (
            <Select
              name={'farm_id'}
              placeholder={intl.formatMessage({ id: 'general.farms' })}
              labelInValue={true}
              layout={'vertical'}
              label={intl.formatMessage({ id: 'general.farms' })}
              onChange={handleFarmChange}
              className={'admin-farm-select'}
            >
              {farms.map((farm: FarmData) => {
                return <SelectOption value={farm.id}>{farm.name}</SelectOption>;
              })}
            </Select>
          )}
          {typeof farmId === 'number' && (
            <>
              <NotificationsBell
                farmId={farmId}
                onClick={() => setBellOpen(true)}
                onRealtime={() => setHasUnopened(true)}
                onRefetchCount={handleRefetchCount}
              />

              <Divider
                orientation="vertical"
                marginLeft={8}
                marginRight={8}
                maxHeight={24}
                thickness={1}
              />
            </>
          )}

          <Profile />
        </div>
      </StyledHeader>

      <Spinner spinning={isSwitchingFarm} size={'large'} fullScreen />

      <BellNotificationsDrawer
        open={bellOpen}
        onClose={() => setBellOpen(false)}
        onHasUnopenedChange={setHasUnopened}
        onNotificationViewed={handleNotificationViewed}
      />
    </>
  );
};

export default DefaultHeader;
